<template>
	<div>
		<div :class="isChain ? 'chain_RelatedReport' : ''" v-if="showTable">
			<h2 class="chain_title1" v-if="isChain">全国{{ title }}相关数据</h2>
			<div class="scrollable-table-wrapper">
				<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table growth_table smwhidth">
					<tr>
						<th></th>
						<th><span class="inline-block width50PC">2024年</span> <span
								class="inline-block width50PC">增长率</span></th>
						<th><span class="inline-block width50PC">2023年</span> <span
								class="inline-block width50PC">增长率</span></th>
						<th><span class="inline-block width50PC">2022年</span> <span
								class="inline-block width50PC">增长率</span></th>
						<th><span class="inline-block width50PC">2021年</span> <span
								class="inline-block width50PC">增长率</span></th>
						<th><span class="inline-block width50PC">2020年</span> <span
								class="inline-block width50PC">增长率</span></th>
						<th><span class="inline-block width50PC">2019年</span> <span
								class="inline-block width50PC">增长率</span></th>
						<th><span class="inline-block width50PC">2018年</span> <span
								class="inline-block width50PC">增长率</span></th>
					</tr>
					<tr>
						<td class="font-weight text-left py-col-15 border-top fixd-title">上市公司</td>
						<td colspan="7"></td>
					</tr>
					<tr v-for="(list, i) in industryList" :key="i + 'ss'" v-if="list.id < 5">
						<td class="text-dent text-left">{{ list.title == '上市公司数' ? '上市公司总数' : list.title }}<span
								class="font-size14" v-if="list.title != '上市公司数'">({{ list.unit ? list.unit : ''
								}})</span></td>
						<td v-for="(item, dataI) in list.data" :key="'s' + dataI"><span
								class="inline-block width50PC">{{
									toFixedFn(item.value) == 0 ? "-" : toFixedFn(item.value) }}</span><span
								class="inline-block width50PC">{{ item.growth == 0 ? '-' : item.growth + '%' }}</span>
						</td>
						<td v-for="(item, dataI) in 7" :key="dataI + '_s'" v-if="list.data.length == 0"><span
								class="inline-block width50PC">-</span><span class="inline-block width50PC">-</span>
						</td>
					</tr>
					<tr>
						<td class="font-weight text-left py-col-15 border-top">新增投资项目</td>
						<td colspan="7"></td>
					</tr>
					<tr v-for="(list, i) in industryList" :key="i + 'tz'"
						v-if="list.title == '投资项目数量' || list.title == '投资项目金额'">
						<td class="text-dent text-left">{{ list.title }}<span class="font-size14"
								v-if="list.title == '投资项目金额'">({{ list.unit ? list.unit : '' }})</span></td>
						<td v-for="(item, dataI) in list.data" :key="dataI + 'itz'"><span
								class="inline-block width50PC">{{
									toFixedFn(item.value) == 0 ? "-" : toFixedFn(item.value) }}</span><span
								class="inline-block width50PC">{{ item.growth == 0 ? '-' : item.growth + '%' }}</span>
						</td>
						<td v-for="(item, dataI) in 7" :key="dataI + '_t'" v-if="list.data.length == 0"><span
								class="inline-block width50PC">-</span><span class="inline-block width50PC">-</span>
						</td>
					</tr>
					<tr>
						<td class="font-weight text-left py-col-15 border-top">新增融资项目</td>
						<td colspan="7"></td>
					</tr>
					<tr v-for="(list, i) in industryList" :key="i + 'rz'"
						v-if="list.title == '融资项目数量' || list.title == '融资项目金额'">
						<td class="text-dent text-left">{{ list.title }} <span class="font-size14"
								v-if="list.title == '融资项目金额'">({{ list.unit ? list.unit : '' }})</span></td>
						<td v-for="(item, dataI) in list.data" :key="'rz' + dataI"><span
								class="inline-block width50PC">{{
									toFixedFn(item.value) == 0 ? "-" : toFixedFn(item.value) }}</span><span
								class="inline-block width50PC">{{ item.growth == 0 ? '-' : item.growth + '%' }}</span>
						</td>
						<td v-for="(item, dataI) in 7" :key="dataI + '_r'" v-if="list.data.length == 0"><span
								class="inline-block width50PC">-</span><span class="inline-block width50PC">-</span>
						</td>
					</tr>
					<tr>
						<td class="font-weight text-left py-col-15 border-top">新增拿地项目</td>
						<td colspan="7"></td>
					</tr>
					<tr v-for="(list, i) in industryList" :key="i + 'nd'"
						v-if="list.title == '拿地项目数量' || list.title == '拿地项目金额' || list.title == '拿地项目面积'">
						<td class="text-dent text-left">{{ list.title }}<span class="font-size14"
								v-if="list.title == '拿地项目金额' || list.title == '拿地项目面积'">({{ list.unit ? list.unit : ''
								}})</span>
						</td>
						<td v-for="(item, dataI) in list.data" :key="'nd' + dataI"><span
								class="inline-block width50PC">{{
									toFixedFn(item.value) == 0 ? "-" : toFixedFn(item.value) }}</span><span
								class="inline-block width50PC">{{ item.growth == 0 ? '-' : item.growth + '%' }}</span>
						</td>
						<td v-for="(item, dataI) in 7" :key="dataI + '_n'" v-if="list.data.length == 0"><span
								class="inline-block width50PC">-</span><span class="inline-block width50PC">-</span>
						</td>
					</tr>
					<!-- 创投项目 -->
					<tr>
						<td class="font-weight text-left py-col-15 border-top">新增创投项目</td>
						<td colspan="7"></td>
					</tr>
					<tr v-for="(list, i) in industryList" :key="i + 'nd'"
						v-if="list.title == '创投项目数量' || list.title == '创投项目金额'">
						<td class="text-dent text-left">{{ list.title }}<span class="font-size14"
								v-if="list.title == '创投项目金额'">({{ list.unit ? list.unit : '' }})</span>
						</td>
						<td v-for="(item, dataI) in list.data" :key="'nd' + dataI"><span
								class="inline-block width50PC">{{
									toFixedFn(item.value) == 0 ? "-" : toFixedFn(item.value) }}</span><span
								class="inline-block width50PC">{{ item.growth == 0 ? '-' : item.growth + '%' }}</span>
						</td>
						<td v-for="(item, dataI) in 7" :key="dataI + '_n'" v-if="list.data.length == 0"><span
								class="inline-block width50PC">-</span><span class="inline-block width50PC">-</span>
						</td>
					</tr>
				</table>
			</div>
			<p v-if="isChain" class="text-center my-2 curp widthPC-100 font-18"
				@click="routerblank('/industryLibrary?type=1&code=' + baseInfo.notionList)">更多相关数据 ></p>
		</div>
	</div>
</template>
<script>
export default {
	name: 'industryChart',
	data() {
		return {
			showTable: false,
		}
	},
	props: {
		industryList: { type: Array, default: [] },
		title: { type: String, default: '' },
		baseInfo: {},
		isChain: { type: Boolean, default: true },//产业链详情和竞争格局、市场规模都用到了这个组件
	},
	mounted() {
			this.init();
	},
	methods: {
		init() {
			// console.log(this.industryList,this.isChain?'产业链详情':'竞争格局、市场规模详情');
			let data = this.industryList;
			for (let i = 0; i < data.length; i++) {
				let item = data[i];
				if (item.data.length > 0) {
					item.isShow = true;
					this.showTable = true;
					break;
				} else {
					item.isShow = false;
				}
			}
		},
		//有小数点四舍五入保留两位小数，没小数点不变
		toFixedFn(number) {
			let fixedNum;
			if (number && String(number).indexOf('.') !== -1) {
				fixedNum = number.toFixed(2);
			} else {
				fixedNum = number;
			}
			return fixedNum;
		},
	}
}
</script>
<style>
.py-col-15 {
	padding: 15px 0 15px 20px !important;
}

.text-dent {
	/* text-indent:2em; */
	padding-left: 35px !important;
}

.min-widht130 {
	min-width: 130px !important;
}

.width50PC {
	width: 100px !important;
}

.inline-block {
	display: inline-block;
	padding: 15px 10px;
	word-wrap: break-word;
	/* border-right: 1px solid #ececec; */
}

.table-min-width {
	min-width: 2000px;
}

.growth_table td {
	padding: 0;
	align-items: center;
	vertical-align: middle;
	min-width: 200px;

}

.growth_table {
	min-width: 2000px;
	width: 100%;
	table-layout: fixed;
	/* 固定表格布局，确保列宽度一致 */
}

.scrollable-table-wrapper {
	height: 900px;
	width: 95%;
	margin: 0 auto;
	overflow: auto;
	/* 使得内容可以横向滚动 */
	margin-left: 40px;
}

/* 定义滚动条整体样式 */
.scrollable-table-wrapper::-webkit-scrollbar {
	width: 10px;
	/* 设置滚动条的宽度 */
	height: 10px;
	/* 设置滚动条的高度 */
	background-color: #e9e8e8;
	/* 背景色 */
	border-radius: 10px;
	/* 圆角 */

}

/* 定义滚动条轨道样式 */
.scrollable-table-wrapper::-webkit-scrollbar-track {
	opacity: 0.5;
	box-shadow: inset 0 0 5px rgb(255, 255, 255);
	/* 轨道阴影 */
}

/* 鼠标滑过时滑块的背景色 */
.scrollable-table-wrapper::-webkit-scrollbar-thumb:hover {
	background: rgb(128, 126, 126);
}

/* 定义滚动条滑块样式 */
.scrollable-table-wrapper::-webkit-scrollbar-thumb {
	background: rgb(197, 197, 197);
	/* 设置滚动条滑块颜色 */
	border-radius: 10px;
	/* 圆角 */

}

.growth_table th {
	font-weight: bold;
	min-width: 200px;
	position: sticky;
	top: 0;
	/* z-index: 1; */
}

.growth_table td:first-child {
	position: sticky;
	left: 0;
	background: #fff;
}

.growth_table th:first-child {
	position: sticky;
	left: 0;
	z-index: 1;
}
</style>